<template>
  <div class="hisse-header">
    <div class="hisse-wrapper">
      <!-- Sol kısım: Hisse kodu ve değişim yüzdesi -->
      <div class="hisse-info">
        <h2 class="hisse-kodu">{{ selectedHisse.hisse_kodu }}</h2>
        <div
          class="degisim-badge"
          :class="
            selectedHisse.degisim_yuzde > 0
              ? 'positive'
              : selectedHisse.degisim_yuzde < 0
              ? 'negative'
              : 'neutral'
          "
        >
          <span class="degisim-icon">{{
            selectedHisse.degisim_yuzde > 0
              ? "▲"
              : selectedHisse.degisim_yuzde < 0
              ? "▼"
              : "■"
          }}</span>
          {{ formatPrice(Math.abs(selectedHisse.degisim_yuzde)) }}%
        </div>
      </div>

      <!-- Sağ kısım: Son fiyat -->
      <div class="fiyat-container">
        <div class="son-fiyat">
          {{ formatPrice(selectedHisse.son_fiyat) }} ₺
        </div>
      </div>
    </div>

    <!-- Alt kısım: Fiyat detayları -->
    <div class="fiyat-detaylari">
      <div class="fiyat-item">
        <span class="label">Düşük</span>
        <span class="value">{{ formatPrice(selectedHisse.dusuk) }}</span>
      </div>
      <div class="fiyat-item">
        <span class="label">Yüksek</span>
        <span class="value">{{ formatPrice(selectedHisse.yuksek) }}</span>
      </div>
      <div class="fiyat-item">
        <span class="label">Açılış</span>
        <span class="value">{{ formatPrice(selectedHisse.acilis) }}</span>
      </div>
      <div class="fiyat-item hacim">
        <span class="label">Hacim (TL)</span>
        <span class="value">{{ formatCurrency(selectedHisse.hacim_tl) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice, formatCurrency } from "@/utils/formatHelpers";

export default {
  props: {
    selectedHisse: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatPrice,
    formatCurrency,
  },
};
</script>

<style scoped>
.hisse-header {
  display: flex;
  flex-direction: column;
  background-color: var(--card-bg);
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  padding: 1.5rem;
  transition: all 0.3s ease;
}

.hisse-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.hisse-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.hisse-kodu {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.02em;
}

.degisim-badge {
  display: flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  gap: 0.25rem;
  transition: all 0.2s ease;
}

.degisim-icon {
  font-size: 0.8rem;
}

.positive {
  background-color: rgba(16, 185, 129, 0.15);
  color: rgb(5, 150, 105);
}

.negative {
  background-color: rgba(239, 68, 68, 0.15);
  color: rgb(220, 38, 38);
}

.neutral {
  background-color: rgba(107, 114, 128, 0.15);
  color: rgb(75, 85, 99);
}

.fiyat-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.son-fiyat {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.02em;
}

.fiyat-detaylari {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(229, 231, 235, 0.5);
}

.fiyat-item {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
}

.value {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* Tablet boyutunda */
@media (max-width: 768px) {
  .hisse-header {
    padding: 1.25rem;
  }

  .hisse-wrapper {
    margin-bottom: 1.25rem;
  }

  .son-fiyat {
    font-size: 1.5rem;
  }

  .hisse-kodu {
    font-size: 1.3rem;
  }
}

/* Mobil boyutunda */
@media (max-width: 640px) {
  .hisse-header {
    padding: 0.75rem;
    border-radius: 12px;
  }

  .hisse-wrapper {
    margin-bottom: 0.75rem;
  }

  .hisse-kodu {
    font-size: 1.1rem;
  }

  .son-fiyat {
    font-size: 1.2rem;
  }

  .degisim-badge {
    padding: 0.25rem 0.5rem;
    font-size: 0.8rem;
  }

  .fiyat-detaylari {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    padding-top: 0.75rem;
  }

  .hacim {
    grid-column: span 1;
  }

  .label {
    font-size: 0.7rem;
  }

  .value {
    font-size: 0.85rem;
  }
}

/* Çok küçük ekranlar */
@media (max-width: 380px) {
  .hisse-header {
    padding: 0.5rem;
  }

  .hisse-info {
    gap: 0.5rem;
  }

  .hisse-kodu {
    font-size: 1rem;
  }

  .son-fiyat {
    font-size: 1rem;
  }

  .degisim-badge {
    padding: 0.2rem 0.4rem;
    font-size: 0.7rem;
  }

  .fiyat-detaylari {
    gap: 0.5rem;
  }
}
</style>
